export default `
  search(cityId: $cityId, filters: $filters, limit: $limit) {
    totalMarkers
    paginator {
      pageNumber
      count
      itemCountPerPage
      pages
      nextPageNumber
      prevPageNumber
    }
    markers {
      id
      coord
      relevance
      instantBooking
      isSelect
      minimumPrice
      rentableUnits {
        id
        adId
        coord
        relevance
        instantBooking
        minimumPrice
      }
    }
    aggregators {
      id
      coord
      relevance
      instantBooking
      minimumPrice
      rentableUnits {
        id
        adId
        coord
        relevance
        instantBooking
        minimumPrice
      }
    }
    homecards(locale: $locale) {
      adId
      aptFeatures
      checked
      currencyIsoCode
      cancellationPolicy
      features
      firstAvailableDate
      id
      isInstantBooking
      noSecurityDeposit
      isFavorite
      isNew
      isSuperlister
      isSelect
      mainPhotoUrl
      monthlyPrice {
        fixedPrice
        minimumPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
        type
      }
      photoUrls {
        homecardHidpi
        homecard
      }
      reviews {
        ratingAverage
      }
      title
      type
      url
    }
  }
`;
